/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ComponentTypeEnum } from './componentTypeEnum';


export interface ReleaseComponent { 
    /**
     * Full Name of the component.
     */
    full_name: string;
    /**
     * Time at which component was added/updated in SI
     */
    last_updated_date?: Date;
    /**
     * AWS Region Wide map containg the value (Image Id, checksum etc) to identify the component uniquely.
     */
    property?: { [key: string]: string; };
    type: ComponentTypeEnum;
}
export namespace ReleaseComponent {
}


